<template>
  <q-dialog position="right">
    <!-- <div class="q-pa-md row items-center q-gutter-md"  style="width: 50%"> -->
    <q-card class="my-card" style="width: 500px; height: 100vh">
      <q-card-section class="column q-gutter-md">
        <!-- items-center -->

        <!--            :disable="domainControlStore.isConnected" -->
        <q-btn
          push
          :loading="!!loading[0]"
          color="secondary"
          :disable="domainControlStore.isConnected"
          @click="connectToDevice"
          style="min-width: 200px"
        >
          {{ domainControlStore.isConnected ? "已连接" : "获取设备列表并配对" }}
          <template v-slot:loading>
            <q-spinner-hourglass class="on-left" />
            Loading...
          </template>
        </q-btn>
        <br />

        <q-btn
          push
          color="secondary"
          v-if="domainControlStore.isConnected"
          @click="domainControlStore.disconnectDevice"
          >断开连接</q-btn
        >

        <p>
          设备状态:
          {{ domainControlStore.isConnected ? "已连接" : "未连接" }}
        </p>
        <template v-if="domainControlStore.isConnected">
          <p>设备名称: {{ domainControlStore.device?.name }}</p>
          <p>
            连接开始时间:
            {{
              domainControlStore.connectStartTime
                ? new Date(domainControlStore.connectStartTime).toLocaleString()
                : ""
            }}
          </p>
        </template>

        <!-- <p>接收信息: {{ pong }}</p>
        <div class="row">
          <q-input
            v-model.number="ping"
            filled
            type="number"
            style="max-width: 200px; margin-right: 20px"
          />
          <q-btn
            v-if="domainControlStore.isConnected"
            push
            color="secondary"
            label="发送"
            @click="write"
          />
        </div>
        <q-btn
          v-if="domainControlStore.isConnected"
          push
          color="secondary"
          label="读取数据"
          @click="read"
        />
        <q-btn
          v-if="domainControlStore.isConnected"
          push
          color="secondary"
          label="获取所有特征"
          @click="getCharacteristics"
        />
        <q-btn
          v-if="domainControlStore.isConnected"
          push
          color="secondary"
          label="读取所有可写特征"
          @click="getCharacteristicsAndRead"
        /> -->
        <!-- <q-btn
          v-if="domainControlStore.isConnected"
          push
          color="secondary"
          label="写入所有可写特征"
          @click="getCharacteristicsAndWrite"
        /> -->
        <!-- <q-btn
          v-if="domainControlStore.isConnected"
          push
          color="secondary"
          label="获取所有服务"
          @click="getAllServices"
        /> -->
        <q-btn
          color="secondary"
          @click="$q.fullscreen.toggle()"
          :icon="$q.fullscreen.isActive ? 'fullscreen_exit' : 'fullscreen'"
          :label="$q.fullscreen.isActive ? '退出全屏' : '全屏显示'"
        />
        <!-- <q-btn color="secondary" @click="handleFullScreen">
          {{ isFullScreen ? "退出全屏" : "全屏显示" }}
        </q-btn> -->
        <q-btn color="secondary" @click="handleRefresh">
          {{ "刷新页面" }}
        </q-btn>
        <!-- <q-btn @click="$q.dark.toggle()">
          {{ $q.dark.isActive ? "浅色模式" : "深色模式" }}
        </q-btn> -->
        <q-toggle
          label="深色模式"
          color="secondary"
          :model-value="$q.dark.isActive"
          @update:model-value="$q.dark.toggle()"
        />
        <q-toggle
          label="显示vconsole"
          color="secondary"
          :model-value="domainControlStore.showVConsole"
          @update:model-value="domainControlStore.changeShowVConsole"
        />
        <q-toggle
          label="显示日志"
          color="secondary"
          :model-value="domainControlStore.printLog"
          @update:model-value="domainControlStore.changePrintLogStatus"
        />
        <q-toggle
          label="显示时间间隔"
          color="secondary"
          :model-value="domainControlStore.printInterval"
          @update:model-value="domainControlStore.changePrintIntervalStatus"
        />
        <data v-if="domainControlStore.printInterval">
          时间间隔 : {{ domainControlStore.notifyInterval }}</data
        >

        <q-btn
          v-if="domainControlStore.showVConsole"
          push
          color="secondary"
          @click="domainControlStore.sentryTest"
          >sentry test</q-btn
        >
      </q-card-section>
    </q-card>
    <!-- </div> -->
  </q-dialog>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { ESP32BLEBluetooth } from "@/services/domainControl";
import { ESP32BLE } from "@/services/domainControl/define";
// import { BleDevice } from "@capacitor-community/bluetooth-le";
import { useDomainControlStore } from "@/stores/domainControl";
import { useQuasar } from "quasar";
import { useRoute } from "vue-router";
const $q = useQuasar();
// const isFullScreen = ref(false);
const route = useRoute();
const domainControlStore = useDomainControlStore();
const loading = ref([] as boolean[]);
// const device = ref<BluetoothDevice | BleDevice | null>(null);
const ping = ref(111);
const pong = ref();

const handleRefresh = () => {
  window.location.reload();
};
//  tab
// const tab = ref("ICC");
const handleDisconnected = async () => {
  domainControlStore.changeIsConnectedStatus(false);
  $q.notify("蓝牙连接已断开");
  loading.value[0] = false;
};
// 链接蓝牙
const connectToDevice = async () => {
  domainControlStore.connectToDevice(
    handleDisconnected,
    loading,
    route.name?.toString()
  );
};

async function getCharacteristics() {
  try {
    const characteristics = await ESP32BLEBluetooth.getCharacteristics();
    console.log(
      "[BOWEN_LOG] 🚀 ~~ getCharacteristics ~~ characteristics:",
      characteristics
    );
    return characteristics;
  } catch (error) {
    console.error("[getCharacteristics] Error getting services", error);
  }
}

async function getCharacteristicsAndRead() {
  try {
    const characteristics = await ESP32BLEBluetooth.getCharacteristics();
    Promise.all(
      characteristics?.map(async (item) => {
        if (item.properties.read) {
          const value = await ESP32BLEBluetooth.readData(
            item.service.uuid,
            item.uuid
          );
          console.log(
            "[BOWEN_LOG] 🚀 ~~ getCharacteristicsAndRead?.map ~~ value:",
            value
          );
          return value;
        }
      }) || []
    );

    return characteristics;
  } catch (error) {
    console.error("[getCharacteristics] Error getting services", error);
  }
}
async function getAllServices() {
  try {
    const services = await ESP32BLEBluetooth.getServices();
    console.log("[getCharacteristics] Error getAllServices services", services);
    return services;
  } catch (error) {
    console.error("[getAllServices] Error getting services", error);
  }
}

async function write() {
  try {
    domainControlStore.writeOutputValue({
      test: ping.value,
    });
  } catch (error) {
    console.error(
      "[write] Error getting services and write characteristics:",
      error
    );
  }
}
async function read() {
  try {
    const data = await ESP32BLEBluetooth.readData(
      ESP32BLE.services[0].uuid,
      ESP32BLE.services?.[0]?.characteristics?.[0]?.uuid || ""
    );
    console.log("[BOWEN_LOG] 🚀 ~~ read ~~ data:", data);
  } catch (error) {
    console.error("[read]Error getting services and  characteristics:", error);
  }
}

const handleNotyfy = (value: string, event: any) => {
  console.log(
    "[BOWEN_LOG] 🚀 ~~ handleNotyfy ~~ event:",
    event.target.service.uuid
  );
  pong.value = value.toString();
};
async function getCharacteristicsAndWrite() {
  try {
    const characteristics = await ESP32BLEBluetooth.getCharacteristics();
    console.log(
      "[BOWEN_LOG] 🚀 ~~ getCharacteristics ~~ characteristics:",
      characteristics
    );
    characteristics?.map((item) => {
      if (item.properties.write) {
        ESP32BLEBluetooth.writeData(
          ping.value + "",
          item.service.uuid,
          item.uuid
        );
      }
      if (item.properties.notify) {
        ESP32BLEBluetooth.startNotifications(
          handleNotyfy,
          item.service.uuid,
          item.uuid
        );
      }
    });
    return characteristics;
  } catch (error) {
    console.error("[getCharacteristics] Error getting services", error);
  }
}
</script>

<style></style>
